export default function FeaturesSection() {
  return (
    <section id="features" className="px-4 md:px-6 py-16 md:py-24 bg-background-100 border-y border-background-200">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Breakthrough AI Compute Applications
          </h2>
          <p className="mt-2 text-foreground-600">
            Precisely grasp core advantages to help you compute efficiently
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="rounded-lg bg-background-50 border border-background-200 p-6">
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-check-double-line text-xl" />
              </span>
              <h3 className="mt-5 font-heading font-semibold text-lg text-foreground-950">
                High-Performance Compute Resources
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                Provide top-tier hardware, ensuring computing speed and stability
              </p>
            </div>
            <div className="rounded-lg bg-background-50 border border-background-200 p-6">
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className="ri-check-double-line text-xl" />
              </span>
              <h3 className="mt-5 font-heading font-semibold text-lg text-foreground-950">
                Flexible Reserved Plans
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                Diverse plan designs to meet different business needs
              </p>
            </div>
            <div className="rounded-lg bg-background-50 border border-background-200 p-6">
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                <i className="ri-customer-service-2-line text-xl" />
              </span>
              <h3 className="mt-5 font-heading font-semibold text-lg text-foreground-950">
                24/7 Technical Support
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                Professional team available anytime to ensure uninterrupted service
              </p>
            </div>
            <div className="rounded-lg bg-background-50 border border-background-200 p-6">
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-fullscreen-line text-xl" />
              </span>
              <h3 className="mt-5 font-heading font-semibold text-lg text-foreground-950">
                Elastic Scaling Capability
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                Adjust compute scale easily as your business grows
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="overflow-hidden rounded-lg">
              <img
                src="https://images.unsplash.com/photo-1523961131990-5ea7c61b2107?ixid=M3w0MzUxNjF8MHwxfHNlYXJjaHwxM3x8ZGF0YSUyMGNlbnRlcnxlbnwwfHx8fDE3NTIyNTc4NjR8MA&ixlib=rb-4.1.0&orientation=landscape&fit=crop&crop=entropy%2Cfaces&auto=format%2Ccompress&w=1280"
                alt="Data center"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="overflow-hidden rounded-lg">
              <img
                src="https://images.unsplash.com/photo-1689442529342-3f1c7513d9ae?fit=crop&crop=entropy%2Cfaces&auto=format%2Ccompress&w=1280"
                alt="Abstract compute"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}